@import '../../themes/capsule.globals';

:host {
  display: block;

  font-family: $font-family-base;

  padding: 0px;
  margin: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-smooth: never;
  font-synthesis: none;
}

:host(.primary) {
  color: var(--color-override, var(--cpsl-color-text-primary));

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--color-override, var(--cpsl-color-text-primary));
  }
}

:host(.secondary) {
  color: var(--color-override, var(--cpsl-color-text-secondary));

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--color-override, var(--cpsl-color-text-secondary));
  }
}

:host(.tertiary) {
  color: var(--color-override, var(--cpsl-color-text-tertiary));

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--color-override, var(--cpsl-color-text-tertiary));
  }
}

:host(.subtle) {
  color: var(--color-override, var(--cpsl-color-text-subtle));

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--color-override, var(--cpsl-color-text-subtle));
  }
}

:host(.inverted) {
  color: var(--color-override, var(--cpsl-color-text-inverted));

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--color-override, var(--cpsl-color-text-inverted));
  }
}

:host(.error) {
  color: var(--color-override, var(--cpsl-color-text-error));

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--color-override, var(--cpsl-color-text-error));
  }
}

:host(.contrast) {
  color: var(--color-override, var(--cpsl-color-text-contrast));

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--color-override, var(--cpsl-color-text-contrast));
  }
}

:host(.regular) {
  font-weight: 400;

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 400;
  }
}

:host(.medium) {
  font-weight: 500;

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 500;
  }
}

:host(.semi-bold) {
  font-weight: 600;

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
  }
}

:host(.bold) {
  font-weight: 700;

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
  }
}

:host(.body-2xs) {
  font-size: var(--cpsl-font-size-body-2xs);

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--cpsl-font-size-body-2xs);
  }
}

:host(.body-xs) {
  font-size: var(--cpsl-font-size-body-xs);

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--cpsl-font-size-body-xs);
  }
}

:host(.body-s) {
  font-size: var(--cpsl-font-size-body-s);
  line-height: 142.857%;

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--cpsl-font-size-body-s);
    line-height: 142.857%;
  }
}

:host(.body-m) {
  font-size: var(--cpsl-font-size-body-m);
  line-height: 150%;

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--cpsl-font-size-body-m);
    line-height: 150%;
  }
}

:host(.body-l) {
  font-size: var(--cpsl-font-size-body-l);
  line-height: 140%;

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--cpsl-font-size-body-l);
    line-height: 140%;
  }
}

:host(.body-xl) {
  font-size: var(--cpsl-font-size-body-xl);

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--cpsl-font-size-body-xl);
  }
}

:host(.heading-xs) {
  font-size: var(--cpsl-font-size-heading-xs);

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--cpsl-font-size-heading-xs);
  }
}

:host(.heading-s) {
  font-size: var(--cpsl-font-size-heading-s);

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--cpsl-font-size-heading-s);
  }
}

:host(.heading-m) {
  font-size: var(--cpsl-font-size-heading-m);
  letter-spacing: -0.4px;

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--cpsl-font-size-heading-m);
    letter-spacing: -0.4px;
  }
}

:host(.heading-l) {
  font-size: var(--cpsl-font-size-heading-l);
  letter-spacing: -1.12px;

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--cpsl-font-size-heading-l);
    letter-spacing: -1.12px;
  }
}

:host(.heading-xl) {
  font-size: var(--cpsl-font-size-heading-xl);
  letter-spacing: -1.28px;

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--cpsl-font-size-heading-xl);
    letter-spacing: -1.28px;
  }
}

:host(.heading-2xl) {
  font-size: var(--cpsl-font-size-heading-2xl);
  letter-spacing: -1.44px;

  > p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--cpsl-font-size-heading-2xl);
    letter-spacing: -1.44px;
  }
}

:host p,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: $font-family-base;

  padding: 0px;
  margin: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-smooth: never;
  font-synthesis: none;

  &::-moz-selection {
    /* Code for Firefox */
    color: var(--cpsl-color-text-inverted) !important;
    background: var(--cpsl-color-background-64) !important;
  }

  &::selection {
    color: var(--cpsl-color-text-inverted) !important;
    background: var(--cpsl-color-background-64) !important;
  }
}
